import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../service/auth/auth.service';
import { RestService } from '../service/rest/rest.service';
import { AdminRestService } from '../service/rest/admin-rest.service';

export interface SettingRow {
  key: string;
  value: string | null;
  valueNum: number | null;
  editValue: string;
  isNumeric: boolean;
}

@Component({
  selector: 'app-admin-settings',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule],
  templateUrl: './admin-settings.component.html',
  styleUrl: './admin-settings.component.css'
})
export class AdminSettingsComponent implements OnInit {
  sessionId = '';
  rows: SettingRow[] = [];
  loading = false;
  saving = false;
  message = '';
  error = '';

  constructor(
    private authService: AuthService,
    private restService: RestService,
    private adminRest: AdminRestService
  ) {}

  ngOnInit() {
    const user = this.authService.getUser();
    this.sessionId = user?.sid || '';
    this.load();
  }

  async load() {
    if (!this.sessionId) return;
    this.loading = true;
    this.error = '';
    this.message = '';
    try {
      const list = await this.adminRest.getAdminSettings(this.sessionId);
      this.rows = (list || []).map((s: any) => {
        const isNumeric = s.valueNum != null;
        const display = s.value ?? (s.valueNum != null ? String(s.valueNum) : '');
        return {
          key: s.key,
          value: s.value ?? null,
          valueNum: s.valueNum ?? null,
          editValue: display,
          isNumeric
        };
      });
    } catch (e: any) {
      this.error = e?.message || 'Failed to load settings';
    } finally {
      this.loading = false;
    }
  }

  async save() {
    if (!this.sessionId) return;
    this.saving = true;
    this.error = '';
    this.message = '';
    try {
      const body: Record<string, string | number> = {};
      for (const row of this.rows) {
        if (row.isNumeric) {
          const n = parseFloat(row.editValue);
          body[row.key] = isNaN(n) ? 0 : n;
        } else {
          body[row.key] = row.editValue ?? '';
        }
      }
      const ok = await this.adminRest.putAdminSettings(this.sessionId, body);
      if (ok) {
        this.message = 'Settings saved.';
        await this.load();
      } else {
        this.error = 'Save failed.';
      }
    } catch (e: any) {
      this.error = e?.message || 'Save failed';
    } finally {
      this.saving = false;
    }
  }
}
